/**
 * Created by Ning Jiang on 11/22/2016.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {DasUBootGameAssets} from "./DasUBootGameAssets";
import {DasUBootMusic, DasUBootSound} from "./sound/DasUBootSound";
import {DasUBootBackgroundElements} from "./view/DasUBootBackgroundElements";
import {DasUBootNormalBetPresentation} from "./gameflow/DasUBootNormalBetPresentation";
import {DasUBootIdleNormalPresentation} from "./gameflow/DasUBootIdleNormalPresentation";
import {DasUBootRoundType} from "./server/DasUBootData";
import {DasUBootModel} from "./server/DasUBootModel";
import {DasUBootReelsView} from "./reels/DasUBootReelsView";
import {DasUBootGameMode} from "./server/DasUBootGameMode";
import {NormalWinPresentation} from "./gameflow/NormalWinPresentation";
import {DasUBootCoverView} from "./view/DasUBootCoverView";
import {DasUBootWinView} from "./view/DasUBootWinView";
import {AvalancheIdlePresentation} from "./gameflow/avalanche/AvalancheIdlePresentation";
import {ModeTransitionScreen} from "./view/ModeTransitionScreen";
import {DasUBootRestore} from "./gameflow/DasUBootRestore";
import {DasUBootAvalancheBetPresentation} from "./gameflow/DasUBootAvalancheBetPresentation";
import {DasUBootAvalancheResultPresentation} from "./gameflow/DasUBootAvalancheResultPresentation";
import {GraphicsPool} from "./utils/GraphicsPool";
import {TemplateAsset, TemplateLoader} from "@nolimitcity/slot-launcher/bin/loader/TemplateLoader";
import {FreespinIdlePresentation} from "./gameflow/freespin/FreespinIdlePresentation";
import {SuperFreespinIdlePresentation} from "./gameflow/superfreespin/SuperFreespinIdlePresentation";
import {DasUBootStatics} from "./utils/DasUBootStatics";
import {NormalSpinReelStop} from "./gameflow/NormalSpinReelStop";


export class DasUBoot extends SlotGame {
    public static model:DasUBootModel;
    public static assetLoader:AssetLoader;
    public static soundPlayer:DasUBootSound;
    public static backgroundElements:DasUBootBackgroundElements;
    public static gameFlowController:GameFlowController;
    public static reelView:DasUBootReelsView;
    public static gameCover:DasUBootCoverView;
    public static winView:DasUBootWinView;
    public static transitionScreen:ModeTransitionScreen;
    public static graphicsPool:GraphicsPool;


    constructor() {
        super();
    }


    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "L4",
                    "M5",
                    "L4",
                    "M3",
                    "M1",
                    "M5",
                    "L4",
                    "L1",
                    "L1",
                    "L4"
                ],
                [
                    "M5",
                    "L5",
                    "L1",
                    "M5",
                    "L5",
                    "M4",
                    "B",
                    "M2",
                    "L4",
                    "S"
                ],
                [
                    "M3",
                    "M4",
                    "L4",
                    "M3",
                    "L4",
                    "L1",
                    "L3",
                    "L5",
                    "M2",
                    "L4"
                ],
                [
                    "L3",
                    "L5",
                    "S",
                    "L1",
                    "M5",
                    "M5",
                    "L2",
                    "L5",
                    "L5",
                    "M1"
                ],
                [
                    "L1",
                    "M5",
                    "L5",
                    "M4",
                    "L5",
                    "M2",
                    "L4",
                    "S",
                    "M5",
                    "L5"
                ],
                [
                    "L3",
                    "M3",
                    "L3",
                    "L2",
                    "L2",
                    "L2",
                    "L5",
                    "L2",
                    "L2",
                    "L2"
                ]
            ],
            "evaluatedArea": [
                [
                    "M3",
                    "M1"
                ],
                [
                    "M5",
                    "L5",
                    "M4"
                ],
                [
                    "M3",
                    "L4",
                    "L1",
                    "L3"
                ],
                [
                    "L1",
                    "M5",
                    "M5",
                    "L2"
                ],
                [
                    "M4",
                    "L5",
                    "M2"
                ],
                [
                    "L2",
                    "L2"
                ]
            ],
            "gameAreaSize": [
                2,
                3,
                4,
                4,
                3,
                2
            ],
            "betWayWins": [],
            "totalSpinWinnings": 0,
            "totalSpinWinningsNonMultiplied": 0,
            "accumulatedRoundWin": 0,
            "reelsNextSpin": "BASE_REELSET",
            "playedBetValue": 0.25,
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false,
                false
            ],
            "scatterPositions": [
                -1,
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "freespinTriggeredThisSpin": false,
            "stickyFSMultiplier": 0,
            "numberOfFreespinPlayed": 0,
            "freespinsLeft": 0,
            "payoutMultiplier": 0,
            "xBombTriggered": false,
            "xBombMultiplier": 0,
            "addedNumberOfFreespinsThisSpin": 0,
            "featureBuyTimesBetValue": [
                {
                    "name": "FREESPIN",
                    "type": "FREESPIN",
                    "price": 75
                },
                {
                    "name": "FREESPIN_SUPER",
                    "type": "FREESPIN",
                    "price": 350
                }
            ],
            "featureBet": false,
            "wasFeatureBuy": false,
            "winWaysAndPossibleWinWays": [
                0,
                0
            ],
            "tempReelNr": 0,
            "roundType": 0
        };
    }

    public getSymbolString(key:string, data:{3:number, 4:number, 5:number, 6:number}):string {
        return `
            <div class="symbol">
            <img src="{{gamePath}}screens/images/symbols/${key}.png">
            <div class="payout-group">
                <div class="payout">
                    <span class="number">6</span>
                    <span class="multiplier" data-multiplier="${data[6] * 0.04}">${data[6] * 0.04}</span>
                </div>
                <div class="payout">
                    <span class="number">5</span>
                    <span class="multiplier" data-multiplier="${data[5] * 0.04}">${data[5] * 0.04}</span>
                </div>
                <div class="payout">
                    <span class="number">4</span>
                    <span class="multiplier" data-multiplier="${data[4] * 0.04}">${data[4] * 0.04}</span>
                </div>
                <div class="payout">
                    <span class="number">3</span>
                    <span class="multiplier" data-multiplier="${data[3] * 0.04}">${data[3] * 0.04}</span>
                </div>
            </div>
            </div>
        `;


    }

    public getPaytable():Promise<string> {
        const templateLoader = new TemplateLoader(SlotGame.apiPlugin.resources.getStaticRoot());
        templateLoader.add({
            name:"Paytable",
            url:"nolimit/screens/paytable.mustache"
        });

        return templateLoader.load().then((assets:TemplateAsset[]) => {
            for (let asset of assets) {
                if (asset.name == "Paytable" && asset.loadedData) {

                    for (let key in DasUBootStatics.symbolValues) {
                        asset.loadedData = asset.loadedData.replace(`{{${key}}}`, this.getSymbolString(key, DasUBootStatics.symbolValues[key]))
                    }
                    return asset.loadedData;
                }
            }
            throw new Error("SlotGame could not load Paytable");
        });
    }


    public init():Promise<NolimitPlugin> {
        return super.init()
            .then((value:NolimitPlugin) => {
                DasUBoot.model = new DasUBootModel(SlotGame.apiPlugin, false);
                DasUBoot.model.logger.level = LogLevel.NONE;
                DasUBoot.gameFlowController = new GameFlowController(SlotGame.apiPlugin, DasUBoot.model);
                DasUBoot.gameFlowController.flowStateLogger.level = LogLevel.DEV;

                return value;
            })
            .then((value:NolimitPlugin) => {
                const fontLoader = new FontLoader(NolimitApplication.resourcePath);
                fontLoader.add(OpenSans.NORMAL_800);

                return fontLoader.load().then((fontResult:boolean) => {
                    return value;
                });

            })
            .then((value:NolimitPlugin) => {


                const winPres = new NormalWinPresentation();
                const idleNormal = new DasUBootIdleNormalPresentation();
                const reelStart = new DasUBootNormalBetPresentation();
                const normalResult = new NormalSpinReelStop();

                const avalancheStart = new DasUBootAvalancheBetPresentation();
                const avalancheResult = new DasUBootAvalancheResultPresentation();

                DasUBoot.gameFlowController.addGameModeFlowStatePresentationMap(DasUBootGameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
                    [FlowState.IDLE, idleNormal],
                    [FlowState.BET, reelStart],
                    [FlowState.RESULT, normalResult],
                    [FlowState.WIN, winPres]
                ]));
                DasUBoot.gameFlowController.addGameModeFlowStatePresentationMap(DasUBootGameMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([
                    [FlowState.IDLE, new FreespinIdlePresentation()],
                    [FlowState.BET, reelStart],
                    [FlowState.RESULT, normalResult],
                    [FlowState.WIN, winPres]
                ]));

                DasUBoot.gameFlowController.addGameModeFlowStatePresentationMap(DasUBootGameMode.SUPER_FREESPIN, new Map<FlowState, FlowStatePresentation>([
                    [FlowState.IDLE, new SuperFreespinIdlePresentation()],
                    [FlowState.BET, reelStart],
                    [FlowState.RESULT, normalResult],
                    [FlowState.WIN, winPres]
                ]));

                DasUBoot.gameFlowController.addGameModeFlowStatePresentationMap(DasUBootGameMode.AVALANCHE, new Map<FlowState, FlowStatePresentation>([
                    [FlowState.IDLE, new AvalancheIdlePresentation()],
                    [FlowState.BET, avalancheStart],
                    [FlowState.RESULT, avalancheResult],
                    [FlowState.WIN, winPres]
                ]));


                return value;
            });
    }

    public getReady():Promise<NolimitPlugin> {
        //Show intro and load game assets
        return super.getReady().then((value:NolimitPlugin) => {

            const fontLoader = new FontLoader(NolimitApplication.resourcePath);
            fontLoader.add(OpenSans.ITALIC_600);
            fontLoader.add(OpenSans.NORMAL_300);
            fontLoader.add(OpenSans.NORMAL_400);
            fontLoader.add(OpenSans.NORMAL_700);

            AssetsConfig.addToAssetsConfig(DasUBootGameAssets.RESOURCES_GROUPS);
            DasUBoot.assetLoader = new AssetLoader(DasUBoot.apiPlugin, NolimitApplication.resourcePath + "/resources/");

            const promises = Promise.all([fontLoader.load(), DasUBoot.assetLoader.load(ResourcesGroupName.MAIN)]);

            return promises.then((values:any) => {
                DasUBoot.createViewsAndComponents();
                
                let nextMusic:DasUBootMusic;
                switch (DasUBoot.model.data.roundType) {
                    case DasUBootRoundType.FREE_SPIN:
                        nextMusic = DasUBootMusic.FREESPIN_MUSIC;
                        break;
                    case DasUBootRoundType.SUPER_FREE_SPIN:
                        nextMusic = DasUBootMusic.SUPER_FREESPIN_MUSIC;
                        break;
                    default:
                        nextMusic = DasUBootMusic.MAIN_GAME_MUSIC;
                        break;
                }
                DasUBoot.soundPlayer.switchMusic(nextMusic);
                
                return values;
            }).then((values:any) =>
                DasUBootRestore.restore(DasUBoot.model.isRestore).then(() => {
                    return value;
                })
            );
        });
    }

    public getReadyToStart():Promise<NolimitPlugin> {
        //Game assets loaded, waiting for user to start game.
        return super.getReadyToStart().then((value:NolimitPlugin) => {
            return value;
        });
    }

    public start():Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.
        return super.start().then((value:NolimitPlugin) => {
            DasUBoot.gameFlowController.start();

            return value;
        });
    }

    private static createViewsAndComponents() {
        //Non views
        DasUBoot.graphicsPool = new GraphicsPool();
        DasUBoot.soundPlayer = new DasUBootSound();

        //Static views
        DasUBoot.backgroundElements = new DasUBootBackgroundElements();
        DasUBoot.backgroundElements.setMode(DasUBoot.model.data.roundType);
        DasUBoot.reelView = new DasUBootReelsView();
        DasUBoot.gameCover = new DasUBootCoverView();
        DasUBoot.winView = new DasUBootWinView();
        DasUBoot.transitionScreen = new ModeTransitionScreen();

        NolimitApplication.addLayerAt(DasUBoot.gameCover.name, DasUBoot.gameCover, 0);
        NolimitApplication.addLayerAt(DasUBoot.winView.name, DasUBoot.winView, 0);
        NolimitApplication.addLayerAt(DasUBoot.backgroundElements.name + "foreground", DasUBoot.backgroundElements.foregroundView, 0);
        NolimitApplication.addLayerAt(DasUBoot.transitionScreen.name, DasUBoot.transitionScreen, 0);
        NolimitApplication.addLayerAt(DasUBoot.reelView.name, DasUBoot.reelView, 0);
        NolimitApplication.addLayerAt(DasUBoot.backgroundElements.name, DasUBoot.backgroundElements, 0);
    }

    public static getBuyFeaturePrice(): number {
        let betLevel = DasUBoot.apiPlugin.freeBets.hasFreeBets() ? DasUBoot.apiPlugin.freeBets.getBet() : DasUBoot.apiPlugin.betLevel.getLevel();
        let price: number = DasUBoot.model.gameData?.playedBetValue || parseFloat(betLevel);
        if (DasUBoot.model.data.wasFeatureBuy || DasUBoot.model.isRestoreFeatureBet) {
            for (let index = 0; index < DasUBoot.model.initData.featureBuyTimesBetValue.length; index++) {
                if (DasUBoot.model.initData.featureBuyTimesBetValue[index].name === DasUBoot.model.buyFeatureName) {
                    price *= DasUBoot.model.initData.featureBuyTimesBetValue[index].price;
                    break;
                }
            }
        }
        return price;
    }

    public static isWinBelowStake(): boolean {
        return DasUBoot.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (DasUBoot.model.data.accumulatedRoundWin <= this.getBuyFeaturePrice());
    }
}
